<template lang="pug">
#relatorio-agricola
    el-card.mb-4.box-card(
        shadow='never',
        :body-style='{ padding: "10px" }',
        style='margin: 20px'
    )
        el-collapse
            el-collapse-item(name='filtro')
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-filter-variant.mr-2(style='font-size: 20px')
                        | Filtros

                el-form.row.m-0.px-2(label-position='top', size='mini')
                    el-form-item.col-6.pr-5
                        label.mb-0 Empresa
                        el-select(
                            v-model='filtro.empresasIds',
                            style='width: 100%',
                            placeholder='Selecione',
                            multiple,
                            value-key='id'
                        )
                            el-option.titulo-empresas(
                                v-for='empresa in empresas',
                                :key='empresa.id',
                                :label='empresa.name',
                                :value='empresa.id'
                            )
                    el-form-item.col-6.pl-5
                        label.mb-0 Usuário
                        el-select(
                            v-model='filtro.usuariosIds',
                            style='width: 100%',
                            filterable,
                            remote,
                            multiple,
                            reserve-keyword,
                            :remote-method='remoteMethodUsuario'
                        )
                            el-option(
                                v-for='usuario in usuarioPesquisado',
                                :key='`${usuario.nome}${usuario.id}`',
                                :label='usuario.name',
                                :value='usuario.id'
                            )
                                | {{ usuario.name }}

                    el-form-item.col-4.pr-5
                        label.mb-0 Data envio
                        .d-flex
                            el-date-picker(
                                v-model='filtro.dataRequisicaoInicio',
                                placement='bottom-start',
                                type='date',
                                placeholder='Selecione',
                                format='dd/MM/yyyy'
                            )
                            span.mx-3 à
                            el-date-picker(
                                v-model='filtro.dataRequisicaoFim',
                                placement='bottom-start',
                                type='date',
                                placeholder='Selecione',
                                format='dd/MM/yyyy'
                            )

                    el-form-item.col-2
                        label.mb-0 Ciclo / Ano
                        el-select(
                            v-model='filtro.safrasIds',
                            style='width: 100%',
                            placeholder='Selecione',
                            multiple,
                            value-key='id'
                        )
                            el-option.titulo-cicloAno(
                                v-for='ciclo in cicloAno',
                                :key='"cicloAno" + ciclo.descricao',
                                :value='ciclo.id',
                                :label='ciclo.descricao'
                            ) {{ ciclo.descricao }}

                    el-form-item.col-2.pl-3
                        label.mb-0 Cultura
                        el-select(
                            v-model='filtro.culturasIds',
                            style='width: 100%',
                            placeholder='Selecione',
                            multiple,
                            value-key='id'
                        )
                            el-option.titulo-cultura(
                                v-for='cultura in culturas',
                                :key='"cultura" + cultura.id',
                                :value='cultura.id',
                                :label='cultura.nome'
                            ) {{ cultura.nome }}

                    el-form-item.col-2.pl-5
                        label.mb-0 Registros Inativos
                        .d-flex
                            el-checkbox(
                                v-model='filtro.registrosInativos',
                                label='true'
                            ) Exibir registros inativos

                    el-form-item.col-2.pl-1.align-items-end.d-flex.justify-content-end
                        BaseButton(icon='el-icon-delete', @click='limparFiltro') Limpar
                        BaseButton(
                            type='primary',
                            icon='el-icon-receiving',
                            @click='buscarDados'
                        ) Filtrar

    el-card.mb-4.box-card(
        v-if='hasMonitoramento && hasDadosGrafico',
        shadow='never'
    )
        .grafico-box
            .grafico-direito
                ChartLine.chart-height(
                    chartId='monitoramentoAgricolaLineId',
                    :chartData='chartMonitoramento.chartData',
                    :chart-options='chartMonitoramento.chartOptions',
                    :styles='chartStyles'
                )

            .grafico-esquerdo
                ChartLine.chart-height(
                    chartId='areaMonitoradaAgricolaLineId',
                    :chartData='chartAreaMonitorada.chartData',
                    :chart-options='chartAreaMonitorada.chartOptions',
                    :styles='chartStyles'
                )

    el-card.box-card(
        v-if='hasMonitoramento',
        shadow='never',
        :body-style='{ padding: "10px" }',
        style='margin: 20px'
    )
        el-table.px-2(:data='monitoramentos', size='mini')
            el-table-column(label='Nome usuário', prop='nomeUsuario', sortable)
            el-table-column(label='Empresa', prop='nomeEmpresa', sortable)
            el-table-column(label='Ciclo/Ano', prop='descricaoSafra', sortable)
            el-table-column(
                label='Cultura',
                prop='nomeCulturaEsperada',
                sortable
            )
            el-table-column(
                label='Data envio',
                prop='dataCadastroFormatada',
                sortable
            )
            el-table-column(label='Área (ha)', align='right', sortable)
                template(slot-scope='scope')
                    div {{ getArea(scope.row.areaHa) }}
            el-table-column(
                label='Código Vega API',
                prop='codigoVegaAPI',
                sortable
            )

        .mt-4.px-2.justify-content-between.d-flex.align-items-center
            BaseButton(
                type='primary',
                icon='el-icon-document',
                @click='exportarDados()',
                size='mini'
            ) Exportar Dados
            el-pagination(
                small,
                background,
                layout='prev, pager, next',
                :page-size='pageParams.size',
                :current-page.sync='pageParams.page',
                :total='totalMonitoramentos',
                @current-change='buscarMonitoramentoAgricola'
            )
            div
                label.label-soma {{ `Σ Total de registros: ${totalMonitoramentos}` }}
                label.label-soma.pl-5
                    i.el-icon-crop
                    | {{ ` Área total (ha): ${getArea(totalAreas)}` }}
</template>

<script>
import ChartLine from '@/components/charts/GraficoLine';
import UsuarioService from '@/services/UsuarioService';
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import UtilsService from '@/services/UtilsService';
import formatters from '@/utils/formatters';
import { isEqual } from 'lodash';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'relatorio-agricola',
    components: {
        ChartLine,
        BaseButton
    },

    emits: ['buscarEmpresas'],

    props: {
        empresas: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    computed: {
        hasMonitoramento() {
            return this.monitoramentos && this.monitoramentos.length > 0;
        },

        hasDadosGrafico() {
            return (
                this.dadosGrafico.monitoramento &&
                this.dadosGrafico.areaMonitorada
            );
        }
    },

    data() {
        return {
            chartMonitoramento: {
                chartData: {
                    labels: [],
                    datasets: []
                },
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        title: {
                            display: true,
                            text: 'Monitoramento Agrícola',
                            font: {
                                size: 18
                            }
                        }
                    }
                }
            },
            chartAreaMonitorada: {
                chartData: {
                    labels: [],
                    datasets: []
                },
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        title: {
                            display: true,
                            text: 'Área Monitorada',
                            font: {
                                size: 18
                            }
                        }
                    }
                }
            },
            chartStyles: {
                height: '300px',
                position: 'relative'
            },
            filtro: {
                empresasIds: [],
                usuariosIds: [],
                safrasIds: [],
                culturasIds: [],
                dataRequisicaoInicio: null,
                dataRequisicaoFim: null,
                registrosInativos: false
            },
            monitoramentos: [],
            dadosGrafico: [],
            pageParams: {
                page: 1,
                size: 50,
                sort: 'data_cadastro,DESC'
            },
            totalMonitoramentos: 0,
            totalAreas: 0,
            usuarioPesquisado: [],
            listaUsuarios: [],
            culturas: [],
            cicloAno: []
        };
    },

    mounted() {
        this.buscarUsuarios();
        this.buscarCulturas();
        this.buscarSafras();
        this.buscarDados();
    },

    methods: {
        getArea(area) {
            return formatters.formatNumber(area, 2);
        },
        remoteMethodUsuario(query) {
            if (query !== '') {
                this.usuarioPesquisado = this.listaUsuarios.filter(item => {
                    return (
                        item.name.toLowerCase().indexOf(query.toLowerCase()) >
                        -1
                    );
                });
            } else {
                this.usuarioPesquisado = this.listaUsuarios;
            }
        },

        async buscarUsuarios() {
            if (this.listaUsuarios.length) return;
            UsuarioService.buscaTodosSemPaginacao('')
                .then(({ data }) => {
                    this.listaUsuarios = data;
                    this.usuarioPesquisado = this.listaUsuarios;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },

        buscarCulturas() {
            UtilsService.getCulturas()
                .then(({ data }) => {
                    setTimeout(() => {
                        Object.keys(data).forEach(item => {
                            this.culturas.push(data[item]);
                            this.culturas.sort((a, b) =>
                                a.nome.localeCompare(b.nome)
                            );
                        });
                    }, 500);
                })
                .catch(error => {
                    this.$notify.error({
                        message: 'Não foi possível buscar os dados de culturas.'
                    });
                    throw error;
                });
        },
        buscarSafras() {
            UtilsService.getSafras().then(response => {
                if (response.status === 200) {
                    this.cicloAno = response.data;
                } else {
                    this.$notify.error({
                        message: 'Ocorreu um erro ao buscar safras'
                    });
                }
            });
        },

        buscarDados() {
            this.buscarMonitoramentoAgricola();
            this.buscarDadosGrafico();
        },

        async buscarMonitoramentoAgricola() {
            try {
                const { data } =
                    await MonitoramentoAgricolaService.consultaRelatorio(
                        this.filtro,
                        this.pageParams
                    );

                this.totalMonitoramentos = data.totalItens;
                this.monitoramentos = data.areasMonitoradas;
                this.totalAreas = 0;
                this.totalAreas = data.areasMonitoradas
                    .map(monitorada => monitorada.areaHa)
                    .reduce(
                        (accumulator, currentValue) =>
                            accumulator + currentValue,
                        this.totalAreas
                    );
            } catch (error) {
                this.$notify.error({
                    message:
                        'Não foi possivel carregar os dados de monitoramento.'
                });
            }
        },

        async buscarDadosGrafico() {
            try {
                const { data } =
                    await MonitoramentoAgricolaService.buscarRelatorioGrafico(
                        this.filtro
                    );
                this.dadosGrafico = data;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possivel carregar os dados do gráfico.'
                });
            }

            if (this.dadosGrafico.monitoramento) {
                this.chartMonitoramento.chartData.labels = [
                    ...new Set(this.dadosGrafico.monitoramento.labels)
                ];
                this.chartMonitoramento.chartData.datasets = [
                    ...new Set(this.dadosGrafico.monitoramento.datasets)
                ];
            }
            if (this.dadosGrafico.areaMonitorada) {
                this.chartAreaMonitorada.chartData.labels = [
                    ...new Set(this.dadosGrafico.areaMonitorada.labels)
                ];
                this.chartAreaMonitorada.chartData.datasets = [
                    ...new Set(this.dadosGrafico.areaMonitorada.datasets)
                ];
            }
        },

        async exportarDados() {
            await MonitoramentoAgricolaService.exportarRelatorio(this.filtro)
                .then(() => {
                    this.$notify.success({
                        message: 'Exportação realizada com sucesso!'
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Erro ao realizar a exportação!'
                    });
                });
        },

        limparFiltro() {
            const filtroCopy = this.filtro;
            this.filtro = {
                empresasIds: [],
                usuariosIds: [],
                safrasIds: [],
                culturasIds: [],
                dataRequisicaoInicio: null,
                dataRequisicaoFim: null,
                registrosInativos: false
            };

            if (!isEqual(filtroCopy, this.filtro)) {
                this.buscarDados();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#relatorio-agricola {
    .el-collapse-item__content {
        padding: 0;
    }

    .el-collapse-item__wrap {
        border-bottom: 0;
    }

    .titulo-empresas {
        text-transform: capitalize;
    }

    .titulo-collapse {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
    }

    .label-soma {
        color: #19194b;
        font-size: 12px;
    }

    .el-radio {
        margin-top: 7px !important;
    }

    .grafico-box {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;

        .grafico-direito {
            width: 47%;
        }

        .grafico-esquerdo {
            width: 47%;
        }
    }
}
</style>
